// extracted by mini-css-extract-plugin
export default {"wrapper":"Advt_wrapper__-4VyR","logo":"Advt_logo__3o5SS","title":"Advt_title__KTBx-","qrBlock":"Advt_qrBlock__Fyv9G","qrCode":"Advt_qrCode__aa+SP"};